import React from 'react';

// THESE PATHS MUST MATCH YOUR FILENAMES IN 'public/clients/' EXACTLY
const clients = [
  { name: 'Vedanta', logo: '/clients/vedanta.png' },
  { name: 'L&T', logo: '/clients/lt.png' },
  { name: 'BGR', logo: '/clients/bgr.png' },
  { name: 'BDL', logo: '/clients/bdl.png' },
  { name: 'LOGOS', logo: '/clients/logos.jpg' },
 
  // Add more here if you have them:
  // { name: 'My Client', logo: '/clients/my-client-logo.jpg' },
];

export const ClientCarousel = () => {
  // Triple the list to ensure the loop is perfectly smooth
  const seamlessClients = [...clients, ...clients, ...clients];

  return (
    <div className="w-full bg-white py-12 overflow-hidden border-y border-gray-100">
      <div className="max-w-7xl mx-auto px-4 mb-8 text-center">
        <p className="text-[#1E5631] font-semibold uppercase tracking-wider text-sm">
          Trusted By Industry Leaders
        </p>
      </div>

      <div className="relative w-full">
        {/* Gradients to fade edges (Professional Look) */}
        <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-white to-transparent z-10"></div>
        <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-white to-transparent z-10"></div>

        {/* The Moving Track */}
        <div 
          className="flex items-center gap-16 animate-scroll hover:pause w-max"
        >
          {seamlessClients.map((client, index) => (
            <div
              key={`${client.name}-${index}`}
              className="w-40 h-24 flex-shrink-0 flex items-center justify-center p-4 bg-white rounded-lg border border-gray-100 shadow-sm hover:shadow-md transition-all duration-300"
            >
              <img
                src={client.logo}
                alt={client.name}
                className="max-w-full max-h-full object-contain"
                // This hides the broken image icon if a file name is wrong
                onError={(e) => {
                  e.target.style.display = 'none';
                  console.error(`Image not found: ${client.logo}`); 
                }}
              />
            </div>
          ))}
        </div>
      </div>

      {/* CSS for Animation */}
      <style>{`
        @keyframes scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-33.33%); }
        }
        .animate-scroll {
          animation: scroll 40s linear infinite;
        }
        /* Pause animation when user hovers over the track */
        .hover\\:pause:hover {
          animation-play-state: paused;
        }
      `}</style>
    </div>
  );
};